export function getRowId(row: Record<string, unknown>, index?: number) {
  if (row?.id != null && row.id !== '') {
    return String(row.id)
  }
  if (row?._gridRowId != null) {
    return String(row._gridRowId)
  }
  const id = `_row_${index ?? Date.now()}_${Math.random().toString(36).slice(2)}`
  row._gridRowId = id
  return id
}
